import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { PATH } from 'src/constants/app';
import { useAppDispatch, useAppSelector } from 'src/store';
import { DiscussionForm, NavigateLink } from 'src/components/coreUI';
import DiscussionList from 'src/containers/CourseDiscussionDetail/DiscussionList';
import { fetchDiscussions } from 'src/thunks/discussion';

const Discussion: React.FC = () => {
  const { class_id, class_topic_id, class_topic_content_id } = useParams<{
    class_id: string;
    class_topic_id: string;
    class_topic_content_id: string;
  }>();
  const dispatch = useAppDispatch();
  const pagination = useAppSelector(
    (state) => state.model.discussion.pagination,
  );

  useEffect(() => {
    if (!class_topic_content_id || !class_topic_id || !class_id) return;
    const promise = dispatch(
      fetchDiscussions({
        class_id,
        class_topic_id,
        class_topic_content_id,
        page:
          pagination.next_page === null
            ? pagination.total_pages
            : pagination.next_page,
      }),
    );

    return () => {
      promise.abort();
    };
  }, [class_id, class_topic_id, class_topic_content_id]);

  return (
    <React.Fragment>
      <NavigateLink
        to={`/${PATH.CLASS}/${class_id}/discussions/${class_topic_content_id}`}
        content={'Go to Forum'}
      />
      <DiscussionForm />
      <DiscussionList />
    </React.Fragment>
  );
};

export default Discussion;
